import { Entity } from '../entity';
import { SystemWorkOrderStatus } from '../job';

export enum BulkInvoiceCommandId {
    Create = "Create"
}

export enum BulkInvoiceLineValue {
    JobType = "Job.Type",
    JobDescription = "Job.Description",
    JobPrimaryContact = "Job.PrimaryContact",
    JobAddressName = "Job.Address.Name",
    JobContractors = "Job.Contractors",
    JobResources = "Job.Resources",
    JobAppointments = "Job.Appointments",
}

export interface BulkInvoice {
    customer: Entity;
    company: Entity;
    invoiceAmount: number;
    totalTime: number;
    itemsAmount: number;
    timesheetsAmount: number;
    status: BulkInvoiceJobStatus;
    jobsCount: number;

    // this info for count the jobs in the backend. Not send them to client
    jobIds: string[];

    // this info for create invoices in the backend. Not send them to client
    jobs: BulkInvoiceJobData[];
}

export interface BulkInvoiceJobData extends Entity {
    codeIds: string[];
    timesheetIds: string[];
}

export interface BulkInvoiceCreateRequestLine {
    customerId: string;
    companyId: string;

    // This info will be populated by the backend
    jobs: BulkInvoiceJobData[];
    customer: Entity;
    company: Entity;
}

export interface BulkInvoiceCreateRequest {
    lines: BulkInvoiceCreateRequestLine[];
    status: BulkInvoiceJobStatus;
    throughDate: Date;
    fromDate: Date;
    invoiceDate: Date;
    timezone: string;
}

export interface BulkInvoiceCommands {
    commandId: BulkInvoiceCommandId;
    data: BulkInvoiceCreateRequest;
}

export enum BulkInvoiceJobStatus {
    InProgress = SystemWorkOrderStatus.InProgress,
    Completed = SystemWorkOrderStatus.Completed,
    Finalised = SystemWorkOrderStatus.Finalised,
}
